"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.papanicolaouMessages = exports.resultMessages = exports.Papanicolaou = exports.Result = void 0;
const schema_1 = require("../../../schema");
var Result;
(function (Result) {
    Result["ABNORMAL"] = "ABNORMAL";
    Result["NORMAL"] = "NORMAL";
})(Result || (exports.Result = Result = {}));
var Papanicolaou;
(function (Papanicolaou) {
    Papanicolaou["YES"] = "YES";
    Papanicolaou["NO"] = "NO";
})(Papanicolaou || (exports.Papanicolaou = Papanicolaou = {}));
exports.resultMessages = {
    [Result.ABNORMAL]: {
        id: "htx.screeningProcedures.gynecology.result.ABNORMAL",
        defaultMessage: "Igen"
    },
    [Result.NORMAL]: {
        id: "htx.screeningProcedures.gynecology.result.NORMAL",
        defaultMessage: "Nem"
    }
};
exports.papanicolaouMessages = {
    [Papanicolaou.YES]: {
        id: "htx.screeningProcedures.gynecology.papanicolaou.YES",
        defaultMessage: "Igen"
    },
    [Papanicolaou.NO]: {
        id: "htx.screeningProcedures.gynecology.papanicolaou.NO",
        defaultMessage: "Nem"
    }
};
const result = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Result.ABNORMAL),
    schema_1.Schema.singleChoiceItem(Result.NORMAL)
])
    .expiration(31104000)
    .interpretation({ vocab: "htx", code: "gynecology_result" });
const papanicolaou = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Papanicolaou.YES),
    schema_1.Schema.singleChoiceItem(Papanicolaou.NO)
])
    .interpretation({ vocab: "htx", code: "papanicolaou" })
    .tag({ vocab: "snomed", code: "440614003" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ result, papanicolaou })
    .tag({ vocab: "snomed", code: "20135006" })
    .tag({ vocab: "snomed", code: "170865004" });
